import { Component, OnInit } from '@angular/core';
import { GetdataService } from '../../services/getdata.service';
import { AuthenticationService } from '../../services/authentication.service';
import { FlashMessagesModule, FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
declare var $ :any;

@Component({
  selector: 'app-view-all-events',
  templateUrl: './view-all-events.component.html',
  styleUrls: ['./view-all-events.component.css']
})
export class ViewAllEventsComponent implements OnInit {

  meetingData:object;
  roomData:object;

  constructor(private getdataService:GetdataService,private router:Router, private authService:AuthenticationService,private _flashMessagesService: FlashMessagesService) { }

  ngOnInit() {

    ////console.log(JSON.parse(this.getdataService.getProfileFromLocalStorage()))
      
    this.getdataService.getEventsByAccountID(JSON.parse(this.getdataService.getProfileFromLocalStorage()).account_ID).subscribe((meetingdata) => {
      this.meetingData =[];
      for(let i=0; i<meetingdata.length; i++){
        this.meetingData[i]={title:'',resourceId:'',id:'',start:0,end:0}
        this.meetingData[i].title = meetingdata[i].event_name;
        this.meetingData[i].resourceId = meetingdata[i].event_room_id;
        this.meetingData[i].id = meetingdata[i]._id;
        this.meetingData[i].start = meetingdata[i].event_start_time;
        this.meetingData[i].end = meetingdata[i].event_end_time;
      }
      ////console.log(this.meetingData)
      this.getdataService.getMeetingRoomsByAccount(JSON.parse(this.getdataService.getProfileFromLocalStorage()).account_ID).subscribe((roomdata) => {
        this.roomData = [];
        for(let i=0; i<roomdata.length; i++){
          this.roomData[i]={id:'',title:''}
          this.roomData[i].id = roomdata[i]._id;
          this.roomData[i].title = roomdata[i].room_name;
        }
        console.log(this.roomData);

        $('#calendar').fullCalendar({
          defaultView: 'agendaDay',
          eventClick: (calEvent, jsEvent, view) => {
            this._flashMessagesService.show('Editing Event:'+calEvent.title, {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});
  
            this.router.navigate(['/admin/editevents/', calEvent.id]);
          
        
         },
          allDaySlot: false,
          events: this.meetingData ,
          resources: this.roomData
        });
     
      },
      err=>{
        //////console.log(err);
        return false;
      });


   
    },
    err=>{
      //////console.log(err);
      return false;
    });

     // [
      //   {title:"event at Arena", start:1537913353873, end:1537993368256, resourceId:"Arena"},
      //   {title:"event at Arena", start:1537913353873, end:1537993368256, resourceId:"Kinsmen_Pine_Room_2"}
      // ]

   
  }

}




// WEBPACK FOOTER //
// ./src/app/components/view-all-events/view-all-events.component.ts